var t={buttonWrapper:"rl2_showmorecatagory-module_buttonWrapper_qxc2R",contentText:"rl2_showmorecatagory-module_contentText_8scaT"};export{t as default};
